import { en, type MessageKey, type Messages } from './en';
import { hi } from './hi';

export type Language = 'en' | 'hi';
export const LANGUAGES: readonly { code: Language; label: string; native: string }[] = [
  { code: 'en', label: 'English', native: 'English' },
  { code: 'hi', label: 'Hindi', native: 'हिन्दी' },
];

export const catalogues: Record<Language, Messages> = { en, hi };

export type MessageVars = Record<string, string | number>;

/** Interpolate {placeholders}; unknown placeholders are left visible so they are noticed. */
export function interpolate(template: string, vars?: MessageVars): string {
  if (!vars) {
    return template;
  }
  return template.replace(/\{(\w+)\}/g, (whole, name: string) => (name in vars ? String(vars[name]) : whole));
}

/** Pure translate: falls back to English, then to the key itself. */
export function translate(lang: Language, key: MessageKey, vars?: MessageVars): string {
  const template = catalogues[lang][key] || en[key] || key;
  return interpolate(template, vars);
}

export function isLanguage(value: unknown): value is Language {
  return value === 'en' || value === 'hi';
}
